import { useEffect } from 'react';

export interface NavbarLoadCheckerProps {
  onLoad: () => void;
}

function NavbarLoadChecker(props: NavbarLoadCheckerProps) {
  useEffect(() => {
    const { onLoad } = props;
    if (onLoad) onLoad();
  }, [props]);

  return null;
}

export default NavbarLoadChecker;
